export const categories = [
  {
    id: 1,
    name: '网红塌房',
    slug: 'wanghong-tafang',
    description: '全网网红翻车、塌房事件独家爆料',
    articleCount: 128,
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20influencer%20scandal%20dark%20moody%20atmosphere%2C%20dramatic%20red%20and%20black%20tones%2C%20digital%20art%20style%2C%20abstract%20social%20media%20icons%20floating%2C%20mysterious%20spotlight%20effect&width=600&height=400&seq=cat-wanghong-01&orientation=landscape',
  },
  {
    id: 2,
    name: '明星黑料',
    slug: 'mingxing-heiliao',
    description: '娱乐圈明星不为人知的内幕与黑历史',
    articleCount: 256,
    image: 'https://readdy.ai/api/search-image?query=Celebrity%20scandal%20abstract%20visualization%2C%20dark%20red%20velvet%20curtain%2C%20spotlight%20beam%2C%20paparazzi%20camera%20flashes%2C%20moody%20cinematic%20atmosphere%2C%20dramatic%20shadows%20and%20high%20contrast&width=600&height=400&seq=cat-mingxing-01&orientation=landscape',
  },
  {
    id: 3,
    name: '今日大瓜',
    slug: 'jinri-dagua',
    description: '每日精选最劲爆的吃瓜热点事件',
    articleCount: 89,
    image: 'https://readdy.ai/api/search-image?query=Breaking%20news%20alert%20abstract%20visual%2C%20glowing%20red%20notification%20bells%2C%20digital%20waves%20and%20particles%2C%20dark%20background%20with%20warm%20orange%20highlights%2C%20modern%20flat%20design%20style&width=600&height=400&seq=cat-dagua-01&orientation=landscape',
  },
  {
    id: 4,
    name: '独家爆料',
    slug: 'dujia-baoliao',
    description: '51吃瓜独家渠道获取的一手猛料',
    articleCount: 67,
    image: 'https://readdy.ai/api/search-image?query=Secret%20document%20leak%20abstract%20concept%2C%20classified%20papers%20with%20red%20stamp%2C%20dark%20atmospheric%20lighting%2C%20mysterious%20smoke%20and%20shadows%2C%20cinematic%20noir%20style%20photography&width=600&height=400&seq=cat-dujia-01&orientation=landscape',
  },
  {
    id: 5,
    name: '视频爆料',
    slug: 'shipin-baoliao',
    description: '实锤视频、录音、聊天记录全曝光',
    articleCount: 143,
    image: 'https://readdy.ai/api/search-image?query=Video%20recording%20abstract%20concept%2C%20red%20record%20button%20glowing%2C%20film%20strips%20and%20digital%20pixels%2C%20dark%20background%20with%20dramatic%20red%20highlights%2C%20modern%20minimalist%20design&width=600&height=400&seq=cat-shipin-01&orientation=landscape',
  },
  {
    id: 6,
    name: '每日大赛',
    slug: 'meiri-dasai',
    description: '每日吃瓜大赛，投票选出今日最劲爆',
    articleCount: 45,
    image: 'https://readdy.ai/api/search-image?query=Trophy%20and%20champion%20podium%20abstract%2C%20golden%20award%20with%20red%20ribbons%2C%20dark%20dramatic%20background%2C%20spotlight%20effect%2C%20competition%20victory%20atmosphere%2C%20elegant%20minimal%20style&width=600&height=400&seq=cat-dasai-01&orientation=landscape',
  },
];

export const hotArticles = [
  {
    id: 1,
    title: '某顶流男星被曝隐婚生子，女方竟是圈内知名经纪人',
    slug: 'dingliu-nanxing-yinhun',
    summary: '近日有知情人士爆料称，某当红顶流男星早已秘密结婚并育有一子，女方身份被扒出竟是圈内知名经纪人，两人疑似因工作关系日久生情。',
    category: '明星黑料',
    categorySlug: 'mingxing-heiliao',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20spotlight%20on%20anonymous%20celebrity%20silhouette%2C%20dark%20red%20theater%20stage%2C%20mystery%20revelation%20atmosphere%2C%20cinematic%20lighting%20with%20smoke%20and%20shadows%2C%20professional%20editorial%20photography&width=800&height=600&seq=article-01&orientation=landscape',
    publishDate: '2026-07-02',
    views: 124580,
    hot: true,
    featured: true,
  },
  {
    id: 2,
    title: '千万级网红直播翻车现场，言行不当引全网愤怒',
    slug: 'wanghong-zhibo-fanche',
    summary: '拥有千万粉丝的知名网红在昨晚直播中言论失当，引发全网网友愤怒声讨，相关话题迅速登上热搜榜首。',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    image: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20disaster%20concept%2C%20broken%20microphone%20and%20camera%20equipment%2C%20dark%20moody%20red%20lighting%2C%20social%20media%20icons%20cracking%2C%20dramatic%20cinematic%20atmosphere&width=800&height=600&seq=article-02&orientation=landscape',
    publishDate: '2026-07-01',
    views: 98730,
    hot: true,
    featured: false,
  },
  {
    id: 3,
    title: '某女团成员被曝恋爱脑，为男友放弃百万代言',
    slug: 'nvtuan-lianainao',
    summary: '人气女团核心成员被曝陷入热恋，为男友推掉价值百万的品牌代言合约，引发粉丝脱粉潮。',
    category: '今日大瓜',
    categorySlug: 'jinri-dagua',
    image: 'https://readdy.ai/api/search-image?query=K-pop%20idol%20group%20backstage%20drama%2C%20dark%20moody%20dressing%20room%2C%20broken%20makeup%20mirror%2C%20red%20and%20black%20color%20palette%2C%20emotional%20melancholic%20atmosphere%2C%20cinematic%20editorial%20style&width=800&height=600&seq=article-03&orientation=landscape',
    publishDate: '2026-07-01',
    views: 86520,
    hot: true,
    featured: false,
  },
  {
    id: 4,
    title: '独家：某导演选角黑幕曝光，潜规则内幕全记录',
    slug: 'daoyan-xuanjiao-heimu',
    summary: '51吃瓜独家获取某知名导演选角内幕资料，潜规则全过程被完整记录，涉及多名新人演员。',
    category: '独家爆料',
    categorySlug: 'dujia-baoliao',
    image: 'https://readdy.ai/api/search-image?query=Film%20director%20casting%20dark%20secret%20concept%2C%20movie%20clapperboard%20with%20red%20warning%20tape%2C%20dark%20cinematic%20studio%2C%20mysterious%20spotlight%20and%20shadows%2C%20dramatic%20noir%20photography%20style&width=800&height=600&seq=article-04&orientation=landscape',
    publishDate: '2026-06-30',
    views: 156780,
    hot: true,
    featured: true,
  },
  {
    id: 5,
    title: '某男星酒驾视频曝光，现场画面触目惊心',
    slug: 'nanxing-jiujia-shipin',
    summary: '某当红男星深夜酒驾视频被路人拍下并上传网络，画面显示其驾驶状态极不稳定，险些造成事故。',
    category: '视频爆料',
    categorySlug: 'shipin-baoliao',
    image: 'https://readdy.ai/api/search-image?query=Night%20city%20street%20accident%20scene%2C%20police%20flashing%20lights%20red%20and%20blue%2C%20dark%20atmospheric%20urban%20environment%2C%20dramatic%20cinematic%20noir%20photography%2C%20blurred%20car%20headlights%2C%20moody%20tension&width=800&height=600&seq=article-05&orientation=landscape',
    publishDate: '2026-06-30',
    views: 112340,
    hot: false,
    featured: false,
  },
  {
    id: 6,
    title: '某女演员被曝整容失败，近照面部僵硬遭群嘲',
    slug: 'nv-yanyuan-zhengrong',
    summary: '曾以清纯形象走红的女演员近期出席活动时面部僵硬不自然，被网友质疑整容过度，前后对比照引发热议。',
    category: '明星黑料',
    categorySlug: 'mingxing-heiliao',
    image: 'https://readdy.ai/api/search-image?query=Theater%20mask%20broken%20cracked%20concept%2C%20drama%20stage%20spotlight%2C%20dark%20red%20velvet%20background%2C%20beauty%20and%20destruction%20metaphor%2C%20cinematic%20artistic%20photography%2C%20moody%20dramatic%20lighting&width=800&height=600&seq=article-06&orientation=landscape',
    publishDate: '2026-06-29',
    views: 78900,
    hot: false,
    featured: false,
  },
  {
    id: 7,
    title: '某富二代网红假人设崩塌，真实家境被扒个底朝天',
    slug: 'fuerge-jia-renshe',
    summary: '以富豪人设走红的某网红被扒出家境普通，豪车豪宅均为租赁，其精心打造的白富美人设彻底崩塌。',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20lifestyle%20illusion%20shattered%2C%20broken%20glass%20and%20diamonds%2C%20dark%20moody%20background%2C%20fake%20wealth%20concept%2C%20dramatic%20red%20and%20gold%20lighting%2C%20cinematic%20editorial%20photography&width=800&height=600&seq=article-07&orientation=landscape',
    publishDate: '2026-06-29',
    views: 92340,
    hot: false,
    featured: false,
  },
  {
    id: 8,
    title: '某男星出轨实锤！酒店监控画面曝光',
    slug: 'nanxing-chugui-shichui',
    summary: '已婚男星被曝出酒店监控画面，与神秘女子同进同出，疑似出轨实锤，引发网友热议。',
    category: '视频爆料',
    categorySlug: 'shipin-baoliao',
    image: 'https://readdy.ai/api/search-image?query=Hotel%20corridor%20surveillance%20footage%20style%2C%20dark%20moody%20hallway%2C%20mystery%20silhouettes%2C%20dramatic%20red%20exit%20sign%2C%20cinematic%20noir%20atmosphere%2C%20grainy%20dramatic%20lighting&width=800&height=600&seq=article-08&orientation=landscape',
    publishDate: '2026-06-28',
    views: 134560,
    hot: true,
    featured: true,
  },
];

export const trendingTopics = [
  { id: 1, title: '某顶流男星隐婚生子', heat: 125000, trend: 'up' },
  { id: 2, title: '千万网红直播翻车', heat: 98000, trend: 'up' },
  { id: 3, title: '女星整容失败曝光', heat: 87000, trend: 'down' },
  { id: 4, title: '导演选角黑幕', heat: 156000, trend: 'up' },
  { id: 5, title: '男星酒驾视频', heat: 112000, trend: 'stable' },
  { id: 6, title: '富二代人设崩塌', heat: 92000, trend: 'down' },
  { id: 7, title: '出轨实锤监控曝光', heat: 134000, trend: 'up' },
  { id: 8, title: '女团成员恋爱脑', heat: 86000, trend: 'stable' },
];

export const comments = [
  {
    id: 1,
    username: '吃瓜群众一号',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20avatar%20portrait%2C%20warm%20red%20and%20orange%20tones%2C%20minimal%20flat%20design%2C%20simple%20shapes%20and%20gradients%2C%20clean%20modern%20style&width=100&height=100&seq=avatar-01&orientation=squarish',
    content: '这也太劲爆了！果然娱乐圈的水深不可测，坐等后续更多实锤！',
    rating: 5,
    date: '2026-07-02',
    likes: 342,
  },
  {
    id: 2,
    username: '娱乐扒皮王',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20avatar%20icon%2C%20coral%20orange%20and%20dark%20red%20palette%2C%20minimalist%20modern%20design%2C%20simple%20circular%20composition%2C%20clean%20flat%20art%20style&width=100&height=100&seq=avatar-02&orientation=squarish',
    content: '51吃瓜的爆料一向很准，这次又是一记重锤，粉丝们要坐不住了。',
    rating: 4,
    date: '2026-07-01',
    likes: 256,
  },
  {
    id: 3,
    username: '真相只有一个',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20face%20avatar%2C%20warm%20terracotta%20and%20brown%20tones%2C%20minimalist%20flat%20design%20style%2C%20simple%20shapes%20composition%2C%20modern%20clean%20aesthetic&width=100&height=100&seq=avatar-03&orientation=squarish',
    content: '早就觉得这个人设太完美了，果然都是包装出来的。支持51吃瓜继续挖掘真相！',
    rating: 5,
    date: '2026-06-30',
    likes: 189,
  },
];

export const faqData = [
  {
    id: 1,
    question: '51吃瓜网站的内容来源可靠吗？',
    answer: '51吃瓜网站聚合全网各大社交平台、论坛及知情人士提供的线索，所有内容均经过多方核实与交叉验证。我们承诺所发布的爆料均基于真实证据，包括截图、录音、视频等实锤材料。同时我们设有严格的内容审核机制，确保信息的准确性与时效性。',
  },
  {
    id: 2,
    question: '如何第一时间获取最新黑料吃瓜资讯？',
    answer: '您可以收藏51吃瓜网站首页并定期刷新访问，我们每日更新全网最新黑料大瓜。此外，建议您关注我们的热门话题榜单和今日大瓜专区，这些区域汇聚了当下最受关注的爆料事件，确保您不会错过任何重要资讯。',
  },
  {
    id: 3,
    question: '51吃瓜网站更新频率是怎样的？',
    answer: '51吃瓜网站实行7x24小时不间断更新机制。我们的编辑团队全天候监控全网动态，确保重大爆料事件能够在第一时间呈现给用户。平均每日更新20-30篇精选爆料文章，涵盖网红塌房、明星黑料、独家爆料、视频实锤等多个分类。',
  },
  {
    id: 4,
    question: '可以在51吃瓜网站投稿爆料吗？',
    answer: '可以的。如果您掌握真实的娱乐圈内幕或网红黑料线索，欢迎通过我们网站底部的联系方式与我们取得联系。请确保您提供的材料真实可靠，并附上相关证据截图或视频。我们将对爆料者信息严格保密，保护每一位线人的安全。',
  },
];

export const siteStats = [
  { label: '累计爆料文章', value: '12,580+', suffix: '篇' },
  { label: '日活跃用户', value: '86,000+', suffix: '人' },
  { label: '全网覆盖话题', value: '3,200+', suffix: '个' },
  { label: '内容更新频率', value: '7x24', suffix: '小时' },
];